var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceTaskscomponent = function SvgWorkspaceTaskscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333 4h8v1.333h-8zm0 2.667h8V8h-8zm0 4h5.333V9.334H1.333zm14-2-1-1-3.66 3.667-2.006-2.001-1 1 3.006 3z",
    fill: "#FAD156"
  })));
};
export default SvgWorkspaceTaskscomponent;